import { Link } from 'react-router-dom';
import './Footer.css';

const LogoIcon = () => (
  <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="8" fill="#534AB7"/>
    <path d="M6 16 Q9.5 7 13 16 Q16.5 25 20 16 Q23.5 7 27 16" stroke="#EEEDFE" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <circle cx="27" cy="16" r="2.5" fill="#AFA9EC"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <LogoIcon />
              <span>KAIROS <span className="footer__ai">AI</span></span>
            </Link>
            <p className="footer__desc">
              Inteligencia Artificial aplicada a tu negocio. Transformamos empresas e instituciones del Tolima y Colombia con soluciones IA de vanguardia.
            </p>
            <p className="footer__location">📍 Ibagué, Tolima · Colombia</p>
          </div>

          <div className="footer__col">
            <h4>Servicios</h4>
            <ul>
              <li><Link to="/servicios">Agentes IA para ventas</Link></li>
              <li><Link to="/servicios">Atención al cliente IA</Link></li>
              <li><Link to="/servicios">Análisis de datos</Link></li>
              <li><Link to="/servicios">Transformación digital</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Empresa</h4>
            <ul>
              <li><Link to="/nosotros">Nosotros</Link></li>
              <li><Link to="/servicios">Servicios</Link></li>
              <li><Link to="/contacto">Contacto</Link></li>
              <li><Link to="/privacidad">Política de privacidad</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Contacto</h4>
            <ul>
              <li><a href="mailto:camilo@kairoslab.com.co">camilo@kairoslab.com.co</a></li>
              <li><a href="https://wa.me/573229385277" target="_blank" rel="noreferrer">WhatsApp</a></li>
              <li><a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a></li>
              <li><a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} KAIROS AI · MULTISISTEM RTV · Todos los derechos reservados</p>
          <p>Diseñado con IA · Ibagué, Tolima</p>
        </div>
      </div>
    </footer>
  );
}
